import { createContext, useContext } from 'react';

import { IScrollingContext } from './types';

const scrollingContext = createContext<IScrollingContext>({} as IScrollingContext);
export const ScrollingContextProvider = scrollingContext.Provider;
export const useScrollingContext = () => useContext(scrollingContext);
